
<div class="d-flex align-center" style="position: relative">
  <!-- file 존재 -->
  <div v-if="target_detail.file" class="d-flex align-center">
    <!-- Excel -->
    <img v-if="target_detail.file.includes('xls') || target_detail.file.includes('csv')"
      src="/assets/data_icon/icon_excel.svg"
      :style="{width: iconWidth, height: iconHeight}"
    >
    <!-- Image -->
    <img v-else-if="target_detail.file.includes('jpg') || target_detail.file.includes('jpeg') || target_detail.file.includes('png')"
      src="/assets/data_icon/icon_img.svg"
      :style="{width: iconWidth, height: iconHeight}"
    >
    <!-- PDF -->
    <img v-else-if="target_detail.file.includes('pdf')"
      src="/assets/data_icon/icon_pdf2.svg"
      :style="{width: iconWidth, height: iconHeight}"
    >
    <!-- JSON -->
    <img v-else-if="target_detail.file.includes('json')"
      src="/assets/data_icon/icon_json2.svg"
      :style="{width: iconWidth, height: iconHeight}"
    >
    <!-- unknown -->
    <img v-else
      src="/assets/data_icon/icon_unknown.svg"
      :style="{width: iconWidth, height: iconHeight}"
    >
  </div>
  <!-- category 별 분류 -->
  <div v-else-if="target_detail.category" class="d-flex align-center">
    <!-- file -->
    <div v-if="target_detail.category === 'file' && target_detail.file" class="d-flex align-center">
      <!-- Excel -->
      <img v-if="target_detail.file.includes('xls') || target_detail.file.includes('csv')"
        src="/assets/data_icon/icon_excel.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- Image -->
      <img v-else-if="target_detail.file.includes('jpg') || target_detail.file.includes('jpeg') || target_detail.file.includes('png')"
        src="/assets/data_icon/icon_img.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- PDF -->
      <img v-else-if="target_detail.file.includes('pdf')"
        src="/assets/data_icon/icon_pdf2.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- JSON -->
      <img v-else-if="target_detail.file.includes('json')"
        src="/assets/data_icon/icon_json2.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- unknown -->
      <img v-else
        src="/assets/data_icon/icon_unknown.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
    </div>
    <!-- RPA -->
    <img v-else-if="target_detail.category === 'rpa'"
      src="/assets/data_icon/icon_rpa2.svg"
      :style="{width: iconWidth, height: iconHeight}"
    >
    <!-- Re:D -->
    <img v-else
      src="/assets/data_icon/icon_recolumn2.svg"
      :style="{width: iconWidth, height: iconHeight}"
    >
  </div>
  <!-- Re:D -->
  <img v-else
    src="/assets/data_icon/icon_recolumn2.svg"
    :style="{width: iconWidth, height: iconHeight}"
  >

  <!-- 즐겨찾기 표시 -->
  <img v-if="showFavorite && favorite"
    src="/assets/favorite-small.svg"
    style="position: absolute; right: 1px; bottom: 1px"
    :style="{width: `calc(${iconWidth}/2)`, height: `calc(${iconHeight}/2)`}"
  >
</div>
